import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme, { isDarkMode }: { isDarkMode: boolean }) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.other.spacing._24,
    gap: theme.other.spacing._16,

    borderTop: isDarkMode
      ? `1px solid ${theme.colors.dark[4]}`
      : `1px solid ${theme.colors.gray2[1]}`,

    '& p': {
      margin: 0,
    },
    '& ul, & ol': {
      paddingLeft: theme.other.spacing._16,
      margin: 0,
    },
    '& li': {
      marginBottom: theme.other.spacing._4,
    },
    '& a': {
      color: isDarkMode ? theme.colors.blue[4] : theme.colors.blue[7],
      textDecoration: 'none',
    },
  },

  tierRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.other.spacing._16,
    marginBottom: theme.other.spacing._16,
  },

  tierSwatch: {
    width: 20,
    height: 20,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
  },

  tierLogo: {
    width: 70,
    padding: theme.other.spacing._16,
    background: theme.white,
    borderRadius: theme.radius.md,

    '&.isDark': {
      background: theme.colors.dark[4],
    },
  },
  tierInfo: {
    flex: '1 0 auto',
  },
  tierNameRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.other.spacing._8,
    marginBottom: theme.other.spacing._4,
  },
}));
